import React from 'react';
import useReveal from '../hooks/useReveal';
import HeroSection from '../components/HeroSection';
import ProductOverviewSection from '../components/ProductOverviewSection';
import BoosterSection from '../components/BoosterSection';
import ComparisonSection from '../components/ComparisonSection';
import ModulesSection from '../components/ModulesSection';
import ContactSection from '../components/ContactSection';

const Home = () => {
  useReveal();
  return (
    <main>
      <HeroSection />
      <ModulesSection />
      <BoosterSection />
      <ProductOverviewSection />
      <ComparisonSection />
      <ContactSection />
    </main>
  );
};

export default Home;
